import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyMijnVerhuisTypesStore from "./property-mijn-verhuis-types.store";
import { IMijnverhuisInfoResponseModel, MijnverhuisConnectionModel, MijnVerhuisRequestModel, IMijnverhuisConnectionModel } from "../../../../models/property/property-mijnverhuis.model";
import Vue from "vue";
import { KeuringsPlatformInfoModel, IKeuringsPlatformInfoModel } from "../../../../models/property/property-keuring-platform.model";

const mijnVerhuisMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
  [propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_REQUEST_INFO]: (
    state: IPropertyEditState,
    param: IMijnverhuisInfoResponseModel
  ) => {
    // state.mijnverhuis.PrimaryContact = param.ContactInfos[0] ? deepClone(param.ContactInfos[0]) : new KeuringsPlatformInfoModel({});
    state.mijnverhuis.PropertySiteId = param.PropertySiteId;
    state.mijnverhuis.PropertyAddress = param.PropertyAddress;
    state.mijnverhuis.PropertyHouseNumber = param.PropertyHouseNumber;
    state.mijnverhuis.PropertyPostCode = param.PropertyPostCode;
    state.mijnverhuis.PropertyCityName = param.PropertyCityName;
    state.mijnverhuis.PropertyPurposeId = param.PropertyPurposeId;
    state.mijnverhuis.PropertyCountryId = param.PropertyCountryId;
    if (param.CategoryTypeId) {
      state.mijnverhuis.CategoryType = param.CategoryTypes.filter(x => x.Id === param.CategoryTypeId)[0];
    }
    if (param.PropertyPurposeId) {
      state.mijnverhuis.Transaction = param.Purposes.filter(x => x.Id === param.PropertyPurposeId)[0];
    }
  },

  [propertyMijnVerhuisTypesStore.Set.MIJNVERHUIS_ASSIGN_VALUE]: (state: IPropertyEditState, mijnverhuis: MijnVerhuisRequestModel) => {
    Object.keys(mijnverhuis).forEach(key => Vue.set(state.mijnverhuis, key, mijnverhuis[key]))
  },

  [propertyMijnVerhuisTypesStore.Set.PRIMARY_CONTACT_ASSIGNVALUE]: (state: IPropertyEditState, mijnverhuis: IKeuringsPlatformInfoModel) => {
    Object.keys(mijnverhuis).forEach(key => Vue.set(state.mijnverhuis.PrimaryContact, key, mijnverhuis[key]))
  },

  [propertyMijnVerhuisTypesStore.Set.PRIMARY_CONTACT_RESET]: (state: IPropertyEditState) => {
    state.mijnverhuis.PrimaryContact = new KeuringsPlatformInfoModel({});
  },

  [propertyMijnVerhuisTypesStore.Set.SECONDARY_CONTACT_ASSIGNVALUE]: (state: IPropertyEditState, mijnverhuis: IKeuringsPlatformInfoModel) => {
    Object.keys(mijnverhuis).forEach(key => Vue.set(state.mijnverhuis.SecondaryContact, key, mijnverhuis[key]))
  },

  [propertyMijnVerhuisTypesStore.Set.SECONDART_CONTACT_RESET]: (state: IPropertyEditState) => {
    state.mijnverhuis.SecondaryContact = new KeuringsPlatformInfoModel({});
  },

  [propertyMijnVerhuisTypesStore.Set.LEAVING_CUSTOMER_ASSIGNVALUE]: (state: IPropertyEditState, mijnverhuis: IKeuringsPlatformInfoModel) => {
    Object.keys(mijnverhuis).forEach(key => Vue.set(state.mijnverhuis.LeavingCustomer, key, mijnverhuis[key]))
  },

  [propertyMijnVerhuisTypesStore.Set.LEAVING_CUSTOMER_RESET]: (state: IPropertyEditState) => {
    state.mijnverhuis.LeavingCustomer = new KeuringsPlatformInfoModel({});
  },

  [propertyMijnVerhuisTypesStore.Set.CONNECTION_ASSIGNVALUE]: (state: IPropertyEditState, mijnverhuis: IMijnverhuisConnectionModel) => {
    Object.keys(mijnverhuis).forEach(key => Vue.set(state.mijnverhuis.Connection, key, mijnverhuis[key]))
  },

  [propertyMijnVerhuisTypesStore.Set.CONNECTION_RESET]: (state: IPropertyEditState) => {
    state.mijnverhuis.Connection = new MijnverhuisConnectionModel({});
  }
};

export default mijnVerhuisMutations;
